/**
 * @description 允许工具类图像处理上传的最大图片数量
 */
export const BATCH_UPLOAD_MAX_IMAGE_COUNT = 20;
